import React from 'react';

import type { ReactNode } from 'react';

import cx from '../../../utils/classNames';
import toCamelCase from '../../../utils/toCamelCase';

import styles from '../textField.module.scss';

/** Custom props */
export type TextfieldHelperTextProps = {
  /** The content of the component */
  children?: ReactNode;

  /** Custom class to overwrite default styling if needed */
  className?: string;
};

export function HelperText(props: TextfieldHelperTextProps) {
  const { children, className } = props;
  const classNames = cx(styles[toCamelCase('textField', 'helperText')], className);

  return (
    <div className={classNames} data-testid="textField-helperText">
      {children}
    </div>
  );
}

export default HelperText;
